<template>
  <div class="flex flex-col md:flex-row md:items-center md:justify-between">
    <h4 class="text-white font-bold">Offers</h4>

    <CreateAgencyOffer @created="$emit('offer-created')" />
  </div>
</template>

<script>
import CreateAgencyOffer from './CreateAgencyOffer.vue';

export default {
  components: {
    CreateAgencyOffer,
  },
};
</script>
